import axios from 'axios'

class CustomersQueries {
    fetchCustomers(queryString = '') {
        const qs = String(queryString || '').replace(/^\?/, '')
        const url = `/customers/customers${qs ? `?${qs}` : ''}`
        return axios.get(url)
    }

    fetchCustomerById(customerId) {
        return axios.get(`/customers/customers/${customerId}`)
    }

    createCustomer(customerData) {
        return axios.post('/customers/customers', customerData)
    }

    updateCustomer(customerData) {
        return axios.put(`/customers/customers/${customerData.id}`, customerData)
    }

    deleteCustomer(customerId) {
        return axios.delete(`/customers/customers/${customerId}`)
    }

    getCustomerAddresses(customerId) {
        return axios.get(`/customers/customer-addresses`, {
            params: { customer_id: customerId, addressType_id: 2 }
        })
    }

    getCustomerTypes() {
        return axios.get('/customers/customers/dicts/types')
    }

    getAddressTypes() {
        return axios.get('/customers/customers/dicts/address-types')
    }

    getCountries() {
        return axios.get('/geolocalizations/geolocalizations/dicts/countries')
    }

    getProductionFileCustomerConfiguration() {
        return axios.get('/files/dicts/production-file-customer-configuration')
    }
}

export default new CustomersQueries()
